import create from 'zustand'

export interface IOnBoardingStore {
  showErrorPopUp: boolean
  toggleShowErrorPopUp: (isShow: boolean) => void
}

const useOnBoardingStore = create<IOnBoardingStore>()((set) => ({
  showErrorPopUp: false,
  toggleShowErrorPopUp: (showErrorPopUp: boolean) =>
    set(() => ({ showErrorPopUp }))
}))

export default useOnBoardingStore
